// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"787":"6b2a87e1","842":"fa09c9c1"}[chunkId] + ".chunk.js";
};